import router from "@/__main__/router.mjs";
import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import { devDebug } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";
import { stringifyPath } from "@/util/path-regexp.mjs";

const MOUSEOVER_WINDOW = 20 * 1000; // 20 seconds

let init: boolean;

let isMousedOver: boolean;
let mouseOverStartTime: number;

let totalTimeMouseOverInWindow: number = 0;
let routeStart: string;
let routeParamsStart: string[];
let urlStart: string;

export function trackMouseOver() {
  // EVENT_APP_RENDER is fired twice, we only want to set this up once
  if (init) return;
  init = true;

  // Mouse could already be in window when app is loaded
  mouseOverStartTime = Date.now();
  if (router.route) {
    routeStart = stringifyPath(router.route.path);
    routeParamsStart = router.route.parameters;
  }
  urlStart = globals.location.href;

  globals.document.addEventListener("mouseenter", handleMouseEnter);
  globals.document.addEventListener("mouseleave", handleMouseLeave);
}

function handleMouseEnter() {
  devDebug("MouseOver: started");
  isMousedOver = true;
  mouseOverStartTime = Date.now();

  if (totalTimeMouseOverInWindow === 0) {
    startMouseOverWindow();
  }
}

async function handleMouseLeave() {
  const wasMousedOver = isMousedOver;

  isMousedOver = false;
  const thisMouseOverTime = Date.now() - mouseOverStartTime;
  totalTimeMouseOverInWindow += thisMouseOverTime;
  devDebug(`MouseOver: stopped, moused over for: ${thisMouseOverTime}ms`);

  // Mouse could already be in window when app is loaded, handle as if mouseenter fired at start
  if (!wasMousedOver) {
    await handleMouseOverWindowEnding();
  }
}

function startMouseOverWindow() {
  devDebug(`MouseOver: new mouseover window for ${MOUSEOVER_WINDOW}ms`);
  if (router.route) {
    routeStart = stringifyPath(router.route.path);
    routeParamsStart = router.route.parameters;
  }
  urlStart = globals.location.href;
  setTimeout(handleMouseOverWindowEnding, MOUSEOVER_WINDOW);
}

async function handleMouseOverWindowEnding() {
  if (isMousedOver) {
    const thisMouseOverTime = Date.now() - mouseOverStartTime;
    totalTimeMouseOverInWindow += thisMouseOverTime;
    devDebug(
      `MouseOver: still moused over while window ended, adding ${thisMouseOverTime}ms for this window`,
    );
    mouseOverStartTime = Date.now();
    startMouseOverWindow();
  }

  devDebug(
    `MouseOver: window ended, mouse over for: ${totalTimeMouseOverInWindow}ms`,
  );
  const timeMouseOver = totalTimeMouseOverInWindow;
  totalTimeMouseOverInWindow = 0;

  await refs.trackEvent(ANALYTIC_EVENTS.MOUSEOVER, {
    timeMouseOver,
    mouseOverWindow: MOUSEOVER_WINDOW,
    routeStart,
    routeParamsStart,
    urlStart,
    routeEnd: stringifyPath(router.route?.path),
    routeParamsEnd: router.route?.parameters,
    urlEnd: globals.location.href,
  });
}

// Setup actually happens through tracker.mjs and calling trackMouseOver()
export function setup() {}

export function teardown() {
  if (!init) return;

  globals.document.removeEventListener("mouseenter", handleMouseEnter);
  globals.document.removeEventListener("mouseleave", handleMouseLeave);
}
